import * as incidentReducer from "../reducers/incidentReducer";

// eslint-disable-next-line import/prefer-default-export
export const {
  getIncidents,
  getIncidentPageData,
  getMineIncidents,
  getMineIncidentNotes,
} = incidentReducer;
